import React from 'react'
import { FEATURE_FLAG_TYPES } from '@mortgage-pos/data'
import { useVariation } from '@mortgage-pos/ui/services/featureFlags'
import { customTextMap } from '../utils/customizationHelpers'

const Error = () => {
  const bankrateCompareEnabled = useVariation(
    FEATURE_FLAG_TYPES.BANKRATE_COMPARE_ENABLED
  )

  const baseLink = customTextMap('sageBaseUrl')

  return (
    <div className="page --mg-bottom">
      <h2 className="page__title">Something went wrong...</h2>
      {bankrateCompareEnabled ? (
        <p className="page__description">
          Please refresh the page or try again later.
        </p>
      ) : (
        <p className="page__description">
          Please refresh the page or contact{' '}
          <a className="link" href={`mailto:hello@${baseLink}`}>
            hello@{baseLink}
          </a>{' '}
          if the problem persists.
        </p>
      )}
    </div>
  )
}

export default Error
